// Registration never subscribes an account implicitly.
// It starts the existing double opt-in newsletter flow only after account creation.
export async function requestNewsletterAfterSuccessfulRegistration({ consent, email, language }, sendRequest) {
  if (consent !== true) return { status: "skipped" };
  const address = typeof email === "string" ? email.trim() : "";
  if (!address || typeof sendRequest !== "function") return { status: "unavailable" };
  const payload = {
    email: address,
    consent: true,
    language: String(language || "").toLowerCase().startsWith("fr") ? "fr" : "en",
  };
  try {
    const response = await sendRequest(payload);
    if (response?.ok !== true) return { status: "unavailable" };
    return { status: "request_accepted" };
  } catch {
    // Optional marketing failure must never undo a successfully created account.
    return { status: "unavailable" };
  }
}
